import { render, staticRenderFns } from "./Healing.vue?vue&type=template&id=7595ac16&scoped=true"
import script from "./Healing.vue?vue&type=script&lang=js"
export * from "./Healing.vue?vue&type=script&lang=js"
import style0 from "./Healing.vue?vue&type=style&index=0&id=7595ac16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7595ac16",
  null
  
)

export default component.exports